import React, { useState, useEffect } from 'react'
import { motion as m } from 'framer-motion'
import { Link, useNavigate } from 'react-router-dom'
import store from '../store/store'

import Burger from './Burger'

import AddRoundedIcon from '@mui/icons-material/AddRounded' // create
import FavoriteBorderRoundedIcon from '@mui/icons-material/FavoriteBorderRounded' // like
import SearchRoundedIcon from '@mui/icons-material/SearchRounded' // find
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded' // profile
import MenuBookRoundedIcon from '@mui/icons-material/MenuBookRounded' // my recipes



export default function Menu() {
    const isMenuOpen = store((state) => state.isMenuOpen)
    const setIsMenuOpen = store((state) => state.setIsMenuOpen)

    const isUserLogged = store((state) => state.isUserLogged)
    const setIsUserLogged = store((state) => state.setIsUserLogged)

    const userId = store((state) => state.user.id)

    const navigate = useNavigate()

    // handle sign out button
    const handleLogginOut = () => {
        setIsUserLogged(false)
        navigate('/')
    }

    const variant =  {
        initial: {
          opacity: 0,
          //x:'100%',
          transition: {
            duration: .8,
          },
        },
        animate: {
          opacity: 1,
          //x: '0%',
          transition: {
            duration: .8,
          },
        },
        exit: {
          opacity: 0,
            //x: '100%',
            transition: {
                duration: .3,
              },
        },
    }

    return (
        <>
            <Burger />
            <div id={isMenuOpen? 'menu_bg_open' : 'menu_bg_close'} onClick={() => setIsMenuOpen(false)}></div>
            <m.div className='menu' id={isMenuOpen?'menu_background_open' : 'menu_background_close'}>

                <m.div id='menu_wrapper'>
                    <h4>Navigation</h4>
                    <div id='menu_link_home' className='menu_link' >
                        <SearchRoundedIcon id='menu_icons' />
                        <Link to='/search' className='menu_link'>find a recipe</Link>
                    </div>
                    {isUserLogged &&
                    <>
                        <Link to={`/recipes-you-like/${userId}`} id='menu_link_my_recipes' className='menu_link' >
                            <FavoriteBorderRoundedIcon id='menu_icons'/>
                            <p className='menu_link'>recipes you like</p>
                        </Link>

                        <Link to={`/new-recipe/${userId}`} id='menu_link_new-recipe' className='menu_link' >
                            <AddRoundedIcon id='menu_icons'/>
                            <p className='menu_link'>create a new recipe</p>
                        </Link>
                    </>
                    }
                </m.div>

                <m.div id='menu_separator'></m.div>
                
                {isUserLogged &&
                <>
                    <m.div id='menu_wrapper'>
                    <h4>Account</h4>
                        <Link to={`/account/${userId}`} id='menu_link_profile' className='menu_link'>
                            <AccountCircleRoundedIcon id='menu_icons'/>
                            <p className='menu_link'>profile</p>
                        </Link>
                        <Link to='/myrecipes' id='menu_link_my_recipes' >
                            <MenuBookRoundedIcon id='menu_icons'/>
                            <p className='menu_link'>my recipes</p>
                        </Link>
                    </m.div>

                    <m.div id='menu_separator'></m.div>
                </>
                } 


                <m.div id='menu_wrapper'>
                    <h4>Legal</h4>
                    <Link id='menu_link_privacy_policy' className='menu_link' to='#' >privacy policy</Link>
                    <Link id='menu_link_terms_of_service' className='menu_link' to='#'>terms of service</Link>
                    <Link id='menu_link_cookie_policy' className='menu_link' to='#' >cookie policy</Link>
                </m.div>

                <m.div id='menu_separator'></m.div>

                {isUserLogged ?
                <m.div 
                    whileTap={{ scale: 0.9 }} 
                    /*whileHover={{ scale: 1.1 }}*/
                    className='menu_link' 
                    id='menu_button_sign_out' 
                    onClick={handleLogginOut}
                >
                    sign out
                </m.div>
                :
                <m.div 
                    whileTap={{ scale: 0.9 }} 
                    /*whileHover={{ scale: 1.1 }}*/
                    className='menu_link' 
                    id='menu_button_sign_out' 
                    onClick={() => navigate('/signin')}
                >
                    sign in
                </m.div>
                }
            </m.div>
        </>
    )
}